module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: false,
		supportLazyloading: true,
		buttonContext: 'costCenters',
		renderEmptyBeforReady: false,
		showHead: true,
		showInsertButton: true,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		// maxNrOfExportElements: 500000,
		// privilegeBase: 'nl_mailings',
		rowActionsProperties: {
			colWidth: '40px',
		// // 	colSpan: 1,
		// // 	rowSpan: 2
		},
		// customColActionsFile: 'templates/newsletter/mailings/table/customColActions',

		// // rowActions: {
		// // 	delete: true,
		// // 	edit: true,
		// // 	customs: [{
		// // 		buttonType: 'showDuplicate',
		// // 		buttonContext: 'mailing'
		// // 	}]
		// // },
		rowActions: {
			// delete: true,
			customs: [
				{
					buttonType: 'delete',
					context: 'costCenter',
					inline: true,
					neutral: true,
				},
			]
		},
		addRowClassViaAttribute: {
			fieldCode:  'type',
			value:      'customFlat',
			class:      'showDeleteButton',
		},

		// autoInsertWhenEmpty: false, // if one opens up this table and there are no data to be shown, then this is an employee trying to create a shippingOrder.
		heartbeatRefreshOn: {
			'reconnect': true,
			// 'resourceChanged.all': true,
			// 'resourceChanged.bo_projects': true,
			// // 'resourceChanged.bo_customers': true,
			// // 'resourceChanged.bo_employees': true,
			// 'resourceChanged.bo_projectTerms': true,
			// 'resourceChanged.bo_projectTermJobs': true,
			// 'resourceChanged.bo_projectTermJobStatus': true,
			// 'resourceChanged.bo_customerContacts': true,
			// 'resourceChanged.bo_shippingOrders': true,
			'resourceChanged.bo_costCenters': true,
		},
	},

	model: {
		// invoiceID: null, // actual invoiceID
	},

	methods: {

		sanitizeEntity: function(refEntity, refPrevEntity){
			refEntity.attributes = refEntity.attributes || {}
			refEntity.meta = refEntity.meta || {}
			refEntity.meta.hasGroupRow =
				!refPrevEntity ||
				((refEntity.attributes || {}).projectTermID && (refPrevEntity.attributes || {}).projectTermID && refEntity.attributes.projectTermID != refPrevEntity.attributes.projectTermID) ||
				(!(refEntity.attributes || {}).projectTermID && (refPrevEntity.attributes || {}).projectTermID) ||
				((refEntity.attributes || {}).projectTermID && !(refPrevEntity.attributes || {}).projectTermID)
		},

		addEntity: function(entity, prevEntity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				// add group line if necessary
				if(entity.meta.hasGroupRow){
					this.model.$table.append(this.include('./groupRow', { config: this.config, resourceData: entity, model: this.model }));
				}

				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		async delete(rowID, rowData, buttonMode){
			if (rowID && ((rowData || {}).attributes || {}).type === 'customFlat'){

				const decitionContext = await this.performDecision(
					'confirm',
					{
						component:  this,
						title:      storage.__('hint.delete.really.costCenter.title'),
						message:    storage.__('hint.delete.really.costCenter.message'),
					}
				)

				if(((decitionContext || {}).decision || {}).type === 'yes'){
					let controller
					this.closest('templates_core_controller_controller', foundController => {
						controller = foundController
					})

					if(controller){
						await controller.performAction(
							controller.prepareAction('delete_costCenters', rowID),
						)
					}
				}
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers 	= this.config.heartbeatRefreshOn || {}
			const key 			= message.heartbeatKey
			const baseFilters 	= (this.model.parentEntityForTable || {}).baseFilters || {}

			if(refreshers[key] && (
				key !== 'resourceChanged.bo_costCenters' ||
				message.data.invoiceID == baseFilters.invoiceID
			)){
				this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},
}
